module.exports = __webpack_public_path__ + "img/pdf_reference_icon.bd28813f.svg";